import { useEffect } from "react"
import PickupMasterReportForm from "./PickupMasterReportForm"



const PickupMasterReport = ({ open }) => {
    useEffect(() => {
        document.title = 'Pickup Master Report'
    }, [])
    return (
        <main id="main" className="main" style={open ? {} : { marginLeft: "0" }}>
            < PickupMasterReportForm />
        </main>
    )
}
export default PickupMasterReport